import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: "[radrQueryOperator]" })
export class QueryOperatorDirective {
  constructor(public template: TemplateRef<any>) {}
}
